import docReady from './Functions/docReady';
import MapNew from './Functions/initMap';
import { buildVisiblePrice } from './Functions/buildVisiblePrice.js'
import tippy, { followCursor } from 'tippy.js';

docReady(function () {

    let printJobsVue = new Vue({
        el: '.pic-under-navbar',
        data: function () {
            return {
                recentPrintJobs: model.recentPrintJobs ?? [],
                singleStep: model.singleStep ?? false,
                interval: undefined,
                showMapModal: false,
                showEmailDialog: false,
                showPriceDialog: false
            }
        },
        mounted: function () {
            this.updateFileStatuses();
            this.interval = setInterval(() => {
                this.updateFileStatuses();
            }, 3000);
        },
        computed: {
            activeJobs: function (){
                return this.recentPrintJobs.filter(x => !x.isError && !x.isCancelled && !x.isPickedUp && !x.isInProgress);
            },
            minPrice: function () {
                return this.activeJobs.reduce((total, obj) => obj.priceRange.minPrice + total, 0)
            },
            maxPrice: function () {
                return this.activeJobs.reduce((total, obj) => obj.priceRange.maxPrice + total, 0)
            },
            totalPrices: function () {
                // Flatten all locationPrices into a single array
                const allPrices = this.activeJobs.flatMap(x => x.priceRange.locationPrices);

                // Group by location and sum prices
                const grouped = {};
                allPrices.forEach(({ id, location, price }) => {
                    if (!grouped[id]) {
                        grouped[id] = { location, price: 0, formattedPrice: 0 };
                    }
                    grouped[id].price += price;
                });

                // Format prices
                Object.values(grouped).forEach(item => {
                    item.formattedPrice = buildVisiblePrice(item.price, model.currencyInfo, 2, 4);
                });

                // Get array of summed prices
                const priceArray = Object.values(grouped).map(item => item.price);

                // Calculate highest and lowest price
                let highestPrice = priceArray.length ? Math.max(...priceArray) : 0;
                let lowestPrice = priceArray.length ? Math.min(...priceArray) : 0;
                let totalPrice = buildVisiblePrice(this.minPrice, model.currencyInfo, 2, 4);

                // Format highest and lowest price
                lowestPrice = buildVisiblePrice(lowestPrice, model.currencyInfo, 2, 4);
                highestPrice = buildVisiblePrice(highestPrice, model.currencyInfo, 2, 4);
                // Optionally, attach to result
                return {
                    grouped,
                    highestPrice,
                    lowestPrice,
                    totalPrice
                };

                //return grouped;
            },
            canPrintEverywhere: function () {
                if (model.singleStep) {
                    return appMain.currentBudget.budget >= this.maxPrice || !this.maxPrice
                } else {
                    return true;
                }
            }
        },
        methods: {
            cancelJob: function (jobId) {
                var job = this.recentPrintJobs.find(x => x.id == jobId);
                job.isInProgress = false;
                job.isError = false;
                job.isPickedUp = false;
                job.isCancelled = true;
            },
            toggleMap: function (selectedPrintPointName) {
                this.showMapModal = !this.showMapModal;

                if (!map) {
                    map = new MapNew(selectedPrintPointName);
                } else {
                    map.changePrintPoint(selectedPrintPointName);
                }
            },
            updateFileStatuses: function () {
                var inProgressJobIds = [];
                this.recentPrintJobs.filter(function (e) {
                    return e.isInProgress;
                }).forEach(element => inProgressJobIds.push(element.id));
                if (inProgressJobIds.length === 0) {
                    return;
                }
                axios.get('/api/v1.0/printjobs/status?id=' + inProgressJobIds.join('&id='), {
                    id: inProgressJobIds
                })
                    .then(function (response) {
                        response.data.forEach(responseElement => {
                            var vueElement = this.recentPrintJobs.find(e => e.id == responseElement.id);
                            vueElement.isCancelled = responseElement.isCancelled;
                            vueElement.isError = responseElement.isError;
                            vueElement.isInProgress = responseElement.isInProgress;
                            vueElement.statusString = responseElement.status;
                        });
                    }.bind(this))
                    .catch(function (error) {
                        console.log(error);
                    })
            }
        }
    })
});

Vue.component('delete-modal', {
    template: '#confirm-delete-template',
    methods: {
        closeModal: function () {
            this.$emit('close-modal');
        },
        confirmDelete: function () {
            this.$emit('delete');
        }
    }
});
Vue.component('price-modal', {
    template: '#price-modal-template',
    methods: {
        closeModal: function () {
            this.$emit('close-modal');
        }
    },
    props: ['data']
});
Vue.component('send-code-to-email', {
    template: '#send-code-to-email-template',
    methods: {
        closeModal: function () {
            this.$emit('close-modal');
        },
        sendCode: function () {
            let email = document.getElementById('jobCodeEmail').value;
            axios.post('/api/v1.0/me/sendJobCodeToEmail', { email: email })
                .then(function (response) {
                    appMain.notifications = [{ type: 'success', message: response.data.message }];
                })
                .catch(function (err) {
                    appMain.notifications = [{ type: 'error', message: err.response.data }];
                });
            this.$emit('close-modal');
        }
    }
})

let map;
var currentTimeZone = Intl.DateTimeFormat().resolvedOptions();
Vue.component('print-job', {
    data: function () {
        return {
            maxLife: 48,
            currencyInfo: model.currencyInfo,
            updating: false,
            pricesOpen: false,
            singleStep: model.singleStep
        }
    },
    props: {
        id: Number,
        serverId: String,
        itemName: String,
        settings: Object,
        isError: Boolean,
        isInProgress: Boolean,
        isCancelled: Boolean,
        isPickedUp: Boolean,
        ageInHours: Number,
        status: String,
        priceRange: Object,
        price: Number,
        index: Number,
    },
    emits: ['toggle-map'],
    template: '#active-job-template',
    methods: {
        toggleMap: function (name) {
            if (this.isWaitingForPickup) {
                if (model.singleStep) {
                    this.$emit('toggle-map');
                } else {
                    this.$emit('toggle-map', this.serverId);
                }
                //if (window.matchMedia('(max-width: 768px)').matches) {
                //    //this.selectPartner();
                //    //this.$emit('select-partner');
                //} else {
                //    if (model.singleStep) {
                //        this.$emit('toggle-map');
                //    } else {
                //        this.$emit('toggle-map', this.serverId);
                //    }

                //}
            }

        },
        openConfirm: function () {
            this.updating = true;
        },
        cancelPrintJob: function () {
            axios.delete('/api/v1.0/printjobs/' + this.id)
                .then(function (response) {
                    this.$emit('cancel', this.id);
                    this.updating = false;
                    //this.isInProgress = false;
                    //this.isError = false;
                    //this.isPickedUp = false;
                    //this.isCancelled = true;
                    //this.updating = false;
                }.bind(this))
                .catch(function (error) {
                    console.log(error);
                })
        }
    },

    mounted: function () {
        if (model.singleStep) {
            tippy('.activePrintJob:nth-of-type(' + (this.index + 1) + ') .bottom div span.hoverHelpItem', {
                followCursor: 'horizontal',
                plugins: [followCursor],
                maxWidth: 'none'
            });
            this.priceRange.locationPrices = this.priceRange.locationPrices.sort((a, b) => (a.price > b.price) ? 1 : ((b.price > a.price) ? -1 : 0));

            this.priceRange.locationPrices.forEach(element => {
                element.formattedPrice = buildVisiblePrice(element.price, model.currencyInfo, 2, 4);
            });
        }
    },
    computed: {
        isJobCancelled: function () {
            return this.isCancelled;
        },
        isWaitingForPickup: function () {
            return !this.isError && !this.isCancelled && !this.isPickedUp && !this.isInProgress
        },
        deviceList: function () {
            var partner = model.devices.find(x => x.id === this.serverId);
            var availableDevices = partner.devices.filter(x => (x.hasColor || !this.settings.isColor) && (x.hasDuplex || !this.settings.isDuplex) && (x.hasA3 || !this.settings.isA3));
            if (availableDevices != undefined) {
                return availableDevices;
            } else {
                return [];
            }

        },
        priceRangeText: function () {
            if (model.singleStep) {
                // Hinnavahemik MEAP
                if (this.priceRange.minPrice != this.priceRange.maxPrice) {
                    return buildVisiblePrice(this.priceRange.minPrice, model.currencyInfo, 2, 4) + ' – ' + buildVisiblePrice(this.priceRange.maxPrice, model.currencyInfo, 2, 4);
                } else {
                    return buildVisiblePrice(this.priceRange.maxPrice, model.currencyInfo, 2, 4)
                }

            } else {
                if (this.price == -1) {
                    // Unlimited
                    return ''
                } else {
                    // Kindel prindipunkt
                    return buildVisiblePrice(this.price, model.currencyInfo, 2, 4);
                }
            }
        },
        statusString: function () {
            if (this.isWaitingForPickup) {
                return model.localization.Pages_Jobs_JobReady_JS.format(this.maxLife - this.ageInHours);
            } else if (this.isPickedUp) {
                return model.localization.Pages_Jobs_JobPickedUp_JS;
            } else if (this.isCancelled) {
                return model.localization.Pages_Jobs_JobCancelled_JS;
            } else if (this.isError) {
                return model.localization.Pages_Jobs_UnknownError_JS;
            } else if (this.isInProgress) {
                return this.status;
            }
            return null;
        },
        dateString: function () {
            var dateObj = new Date(Date.now() - (this.ageInHours * 3600000)).toLocaleString(currentLanguageCode, {
                timeZone: currentTimeZone.timeZone,
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric" });
            return dateObj;

        }
    }
})
